// Cloudinary transform for the v7 monthly-upsell cover photo: 2:1 for
// the panel aesthetic, 960×480 (the widget caps at 30rem ≈ 480px wide,
// doubled for retina), fill-crop because the source jpg in Cloudinary is
// produced at a different aspect. fetchFormat/quality 'auto' let
// Cloudinary pick the best codec + compression for the browser.
//
// Its own module (not a const in Upsell.jsx) so the Impact Hub edit
// previews (formMocks' UpsellBanner + Content) can request the exact
// same derivation URL as the donor widget — one Cloudinary transform,
// one cached asset, so the preview warms it and the first donor doesn't
// wait on it. Importing Upsell.jsx just for the const would drag its
// heart-confetti + component deps into the IH bundle.
export const COVER_TRANSFORM = {
  width: 960,
  height: 480,
  crop: 'fill',
  fetchFormat: 'auto',
  quality: 'auto',
}
